export function loginStart (state) {
  state.loggingIn = true
}
export function loginStop (state, errorMessage) {
  state.loggingIn = false
  state.loginError = errorMessage
}
export function showAlert (state, value, type) {
  //console.log(value, type)
  if (value.type == 1)
  state.alert = value.value
  else if (value.type == 2)
  state.alert2 = value.value
}
export function updateAccessToken (state, ELEV_SESSION_INFO) {
  if (ELEV_SESSION_INFO) {
    state.ELEV_SESSION_INFO = ELEV_SESSION_INFO
    // state.userFullName = ELEV_SESSION_INFO.name + ' ' + ELEV_SESSION_INFO.lastName
  } else {
    state.ELEV_SESSION_INFO = {}
  }
}
export function login (state, data) {
  localStorage.setItem('ELEV_SESSION_INFO', JSON.stringify(data.ELEV_SESSION_INFO))
  state.ELEV_SESSION_INFO = data.ELEV_SESSION_INFO
  state.user = data.user
}
export function dataUser (state, data) {
  console.log(data)
  state.user = data
}
export function logout (state) {
  localStorage.removeItem('ELEV_SESSION_INFO')
  state.ELEV_SESSION_INFO = ''
  state.user = ''
}
